import { getIdFromYoutubeUrl } from "./getIdFromYoutubeUrl.js";

export function getThumbnailURLFromYoutubeURL(youtubeURL: string | URL): string {
	return `https://img.youtube.com/vi/${getIdFromYoutubeUrl(youtubeURL)}/hqdefault.jpg`;
}
